export const getQueryParams = (pathname: string) => {
  const queryParams: { [key: string]: string } = {};

  pathname
    .split("?")[1]
    .split("&")
    .forEach((keyValuePair) => {
      const [key, value] = keyValuePair.split("=");

      queryParams[key] = value;
    });

  return queryParams;
};

export const getQueryString = (query: { [key: string]: string | undefined }) =>
  Object.entries(query)
    .filter(([k, v]) => v !== undefined)
    .map(([key, value]) => `${key}=${value}`)
    .join("&");
